import { render, staticRenderFns } from "./FormRoster.vue?vue&type=template&id=559be762&scoped=true&"
import script from "./FormRoster.vue?vue&type=script&lang=js&"
export * from "./FormRoster.vue?vue&type=script&lang=js&"
import style0 from "./FormRoster.vue?vue&type=style&index=0&id=559be762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559be762",
  null
  
)

export default component.exports